import React, { useEffect, useState } from "react";
import Select, { components } from "react-select";
import { useDispatch } from "react-redux";
import ReusableModal from "../../ExtraComponents/ReusableModal";
import { getAllAgent, updateAgentsPricingData } from "../../ReduxStore/Slice/Systemsetting/SystemsettingSlice";
import { getChargeBasisAll } from "../../ReduxStore/Slice/Pricing/ChargeBasisSlice";
import Swal from "sweetalert2";

const Systemsetting = () => {
  const dispatch = useDispatch();
  const agent_id = localStorage.getItem("agent_id");
  const [isLoading, setIsLoading] = useState(false);
  const userDetails = JSON.parse(localStorage.getItem("details"));
  

  console.log("userDetails", userDetails);
  const host = `${window.location.origin}`;

  // console.log("host -->> ", host);
  let showPriceUpdateSection = false;

  if (window.location.hostname === "localhost" && Number(agent_id) === 48) {
    showPriceUpdateSection = true;
  }
  else if (host === 'https://proposal.nomismasolution.co.uk' && Number(agent_id) === 39) {
    showPriceUpdateSection = true;
  } else if (host !== 'https://proposal.nomismasolution.co.uk' && (Number(agent_id) === 48 || Number(agent_id) === 2) && window.location.hostname !== "localhost") {
    showPriceUpdateSection = true;
  }




  const [showmodal, setShowmodal] = useState(false);
  const [allAgentData, setAllAgentData] = useState([]);
  const [chargeBasisData, setChargeBasisData] = useState([]);

  
  // const CheckboxOption = (props) => (
  //   <components.Option {...props}>
  //     <div style={{ display: "flex", alignItems: "center" }}>
  //       <input
  //         type="checkbox"
  //         checked={props.isSelected}
  //         readOnly
  //         style={{
  //           marginRight: 8,
  //           width: 16,
  //           height: 16,
  //           cursor: "pointer",
  //           accentColor: "#ff2e95",
  //         }}
  //       />
  //       <span>{props.label}</span>
  //     </div>
  //   </components.Option>
  // );

  const CustomPlaceholder = (props) => (
    <components.Placeholder {...props}>
      <div style={{ display: "flex", alignItems: "center", gap: 6 }}>
        <i
          className="ri-search-line"
          style={{ color: "#3d3d3d", fontSize:"14px" }}
        ></i>
        <span style={{ color: "#3d3d3d", fontSize:"14px" }}>Search agent</span>
      </div>
    </components.Placeholder>
  );

  useEffect(() => {
    getAllAgentData();
    getChargeBasisData();
  }, []);

  const getChargeBasisData = async () => {
    const req = {
      agent_id: agent_id,
      page: 1,
      limit: 2,
      search: ""
    };

    await dispatch(getChargeBasisAll(req)).unwrap()
      .then((response) => {
        if (response.status) {
          setChargeBasisData(response.data);
        } else {
        }
      })
      .catch((error) => {
        console.error("Error fetching charge basis data:", error);
      });
  };

  const customStyles = {
    option: (base) => ({
      ...base,
      backgroundColor: "transparent",
      color: "#333",
      padding: "8px 12px",
      cursor: "pointer",
      "&:hover": { backgroundColor: "#f5f5f5" },
    }),

    menu: (base) => ({
      ...base,
      backgroundColor: "#ffffff", // 👈 WHITE BG CHANGE HERE
      border: "1px solid #000000ff", // 👈 LIGHT BORDER

      boxShadow: "0 6px 20px rgba(0,0,0,0.08)",
      marginTop: 6,
      overflow: "hidden",
    }),

    multiValueLabel: (base) => ({
      ...base,
      color: "#ff2e95",
      fontWeight: 500,
    }),
  };

  const options = [
    { value: "starter", label: "Starter Plan" },
    { value: "business", label: "Business Plan" },
    { value: "enterprise", label: "Enterprise Plan" },
    { value: "premium", label: "Premium Plus" },
    { value: "vip", label: "VIP Exclusive" },
  ];

  const SELECT_ALL_OPTION = {
    label: "Select All",
    value: "select_all",
  };
  //const allOptions = [SELECT_ALL_OPTION, ...options];
  const allOptions = [SELECT_ALL_OPTION, ...allAgentData];
  const getAllAgentData = async () => {
    let req = { agent_id: agent_id };
    await dispatch(getAllAgent(req))
      .unwrap()
      .then((response) => {
        if (response.status) {
          const data = response?.data?.map((item) => ({
            value: item.id,
            label: item.agent_name
          }));

          setAllAgentData(data);
        } else {
          setAllAgentData([]);
        }
      })
      .catch((error) => {
        console.log(error);
      });
  };

  const [selectedOptions, setSelectedOptions] = useState([]);
  const [selectAllValue, setSelectAllValue] = useState(false);

  const handleChange = (selected) => {
    if (!selected) {
      setSelectedOptions([]);
      return;
    }

    const isSelectAll = selected.some(
      (opt) => opt.value === SELECT_ALL_OPTION.value
    );

    if (isSelectAll) {
       setSelectAllValue(true)
      // If all options already selected → unselect all
      if (selectedOptions.length === allAgentData?.length) {
        setSelectedOptions([]);
      } else {
        setSelectedOptions(allAgentData);
      }
    } else {
      setSelectedOptions(selected);
      setSelectAllValue(false)
    }
  };

  const isAllSelected =
    selectedOptions.length === allAgentData?.length && allAgentData?.length > 0;



  const CheckboxOption = (props) => {
    const isSelectAll = props.data.value === "select_all";

    const checked = isSelectAll
      ? isAllSelected
      : props.isSelected;

    return (
      <components.Option {...props}>
        <div style={{ display: "flex", alignItems: "center" }}>
          <input
            type="checkbox"
            checked={checked}
            readOnly
            style={{
              marginRight: 8,
              width: 16,
              height: 16,
              cursor: "pointer",
              accentColor: "#ff2e95",
            }}
          />
          <span>{props.label}</span>
        </div>
      </components.Option>
    );
  };



  const handleSubmit = async () => {
    // Handle the submit action here
  //  console.log("Selected Options:", selectedOptions);

    if (chargeBasisData?.length === 0) {
      Swal.fire({
        icon: 'warning',
        title: 'Action Required',
        text: 'Please add pricing data first. Only after that you will be able to update the pricing.',
        confirmButtonText: 'OK'
      });
      setShowmodal(false);
      return;
    }


    if (selectedOptions?.length === 0) {
      Swal.fire({
        icon: 'warning',
        title: 'No Agents Selected',
        text: 'Please select at least one agent to update pricing.',
        confirmButtonText: "ok"
      });
      setShowmodal(false);
      return;
    }

    setIsLoading(true);
    let req = { agent_id: agent_id, from_agent: agent_id, to_agents: selectedOptions.map(item => item.value) ,user_id: userDetails?.id };
    await dispatch(updateAgentsPricingData(req))
      .unwrap()
      .then((response) => {

        if (response.status) {

          setSelectedOptions([]);
          //  setShowmodal(false);
          //  setIsLoading(false);

          Swal.fire({
            icon: 'success',
            title: 'Pricing Updated',
            text: response.message,
            confirmButtonText: "OK"
          }).then(() => {
            setShowmodal(false);
            setIsLoading(false);

          });

        } else {
          setSelectedOptions([]);
          Swal.fire({
            icon: 'error',
            title: 'Update Failed',
            text: response.message,
            confirmButtonText: "ok"
          }).then(() => {
            setShowmodal(false);
            setIsLoading(false);

          });

        }
      })
      .catch((error) => {
        console.log(error);
        setSelectedOptions([]);
        Swal.fire({
          icon: 'error',
          title: 'Error',
          text: 'An error occurred while updating pricing.',
          confirmButtonText: "ok"
        }).then(() => {
          setShowmodal(false);
          setIsLoading(false);

        });
      });



  }



 console.log("selectAllValue", selectAllValue);
  useEffect(() => {
    if (isLoading) {
      Swal.fire({
        title: '',
        html: '<div style="height:250px;"><div class="loader" style="margin:0px auto;"></div><p class="text-white mt-3">Please Wait...</p></div>',
        showConfirmButton: false,
        allowOutsideClick: false,
        allowEscapeKey: false,
        background: 'transparent',
        backdrop: 'rgba(229, 233, 236, 0.2)',
        // timer: null,
        customClass: {
          popup: 'no-shadow',
        }
      });
    } else {
      Swal.close();
    }
  }, [isLoading]);


  return (
    <div>



      <div className="pagetitle mb-5">
        <h4 className="page-title" style={{ fontSize: "24px" }}>
          System Settings
        </h4>
      </div>

      <div className="card shadow-none" style={{ background: "#F7F9FB" }}>
        <div className="card-header bg-transparent border-0">
          <div className="card-title">
            Select the agent where you want to update the pricing
          </div>
        </div>

        <div className="card-body">
          <div className="row">
            {/* SELECT BOX */}
            <div className="col-md-6 col-sm-6">
              <Select
                options={allOptions}
                value={selectedOptions}
                isMulti
                closeMenuOnSelect={false}
                hideSelectedOptions={false}
               // controlShouldRenderValue={false}
                controlShouldRenderValue={!selectAllValue}
                components={{
                  Option: CheckboxOption,
                  Placeholder: CustomPlaceholder,
                }}
                styles={customStyles}
                onChange={handleChange}
                isDisabled={!showPriceUpdateSection}
              />


            </div>

            {/* BUTTON */}
            <div className="col-md-4 col-sm-4">
              <button
                className="btn btn-pink"
                onClick={() => setShowmodal(true)}
                disabled={!showPriceUpdateSection}
              >
                Update Pricing
              </button>
            </div>
          </div>
        </div>
      </div>





     <ReusableModal
  class="systemsettimg-modal"
  show={showmodal}
  modalContentClass="systemsetting-modal"
  title={
    <>
      Doing this will update all the charge Basis, Services, & Packages in the selected Agents.
      <br />
      <br />
      
      This cannot be undone.
    </>
  }
  onClose={() => setShowmodal(false)}
  footer={
    <div className="justify-content-center d-flex w-100">
      <button
        type="button"
        className="btn btn-outline-pink rounded w-auto me-3"
        onClick={() => setShowmodal(false)}
      >
        Cancel
      </button>
      <button
        type="button"
        className="btn btn-pink rounded w-auto"
        onClick={handleSubmit}
      >
        Proceed
      </button>

      
    </div>
  }
/>

    </div>
  );
};

export default Systemsetting;
